import axios from 'axios'

export const loginService = (email, password) => {
    return axios.post('/login', { email: email, password: password }, {
        withCredentials: true,
    })
}
export const logoutService = () => {
    return axios.post('/logout', {}, {
        withCredentials: true,
    }).then(function() {
        location.reload();
    })
}
export const ForgetPasswordService = email => {
    return axios.post('/forgot-password', { email: email }, {
        withCredentials: true
    })
}

export const ResetPasswordService = (email, token, password, route) => {
    return axios.post(route, {
        email: email,
        token: token,
        password: password,
        password_confirmation: password,
    },
    {
        withCredentials: true,
    })
}
export const FormCreatorClientService = (formElements, route, type) => {
    if(type === 'edit'){
        return axios.post(route, formElements, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })

    }else{
        return axios.post(route, formElements, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
}
export const dataTableClientService = (route) => {
    return axios.get(route, {
        withCredentials: true,
    })
}

export const dataTableDeleteClientService = (route) => {
    return axios.delete(route, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const MasterDataUploaderService = (formElements, route) => {
    return axios.post(route, formElements, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const resetPassword = (formElements, route) => {
    return axios.post(route, formElements, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const SendNewMailModal = (formElements, route) => {
    return axios.post(route, formElements, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const ConfirmModalClient = (route) => {
    return axios.post(route, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const getDataClient = (route) => {
    return axios.get(route, {
        withCredentials: true,
    })
}
export const submitClientService = (formElements, route) => {
    return axios.post(route, formElements, {
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const deleteNotificationClient = (route) => {
    return axios.patch(route, {},{
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
